export default __webpack_public_path__ + "static/media/915.cf344af4.png";